import { useDestinationContext } from '@/src/contexts'

import PlacesToVisit from './placesToVisit'

const PlacesToVisitWrapper = () => {
    const { destinationData: { sections } } = useDestinationContext()
    const places = sections.placesToVisit
    if (!places?.length) return null

    return <PlacesToVisit places={places} />
}

export default PlacesToVisitWrapper
